document.addEventListener("DOMContentLoaded", (event) => {
  let toggleSwitch = document.querySelector('.al-toggle-switch input#plan_toggle_check');

  let selectedOption = document.querySelector('.mini-sub-widget input[name="mini_mode"]:checked').value;

  if (toggleSwitch) {
    toggleSwitch.addEventListener('change', (e) =>  {
        if (toggleSwitch.checked) {
            const subLabel = document.querySelector('.mini-sub-widget label[for="subara"]');
            subLabel.click();
        } else {
            const otLabel = document.querySelector('.mini-sub-widget label[for="oncera"]');
            otLabel.click();
        }
    })
  }

});